import React from 'react';
import { compose, withProps } from 'recompose';
import { Field, formValueSelector } from 'redux-form/immutable';
import { connect } from 'react-redux';

import { TextArea } from '../../../../app/components/Form';
import { withCustomer } from '../../../../app/containers';
import { useTranslation } from 'react-i18next';

const Comment = compose(
  connect((state, { form, fieldName }) => ({
    customerId: formValueSelector(form)(state, `${fieldName}.customer`),
  })),
  withCustomer,
  withProps(({ customer }) => ({
    customerName: customer ? customer.get('name') : '',
  })),
)(({ fieldName, customerName }) => (
  <Field
    label={`${customerName}`}
    name={`${fieldName}.comment`}
    component={TextArea}
    maxLength={500}
    showCounter
    testID="CommentTextArea"
  />
));

function Comments({ fields, form }) {
  const { t } = useTranslation();
  if (fields.length === 0) {
    return null;
  }

  return (
    <div>
      <div>{t("Kommentar gällande arbetet på")}:</div>
      {fields.map(fieldName => (
        <Comment key={fieldName} form={form} fieldName={fieldName} />
      ))}
    </div>
  );
}

export default compose()(Comments);
